import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const RegistrationPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-8 pt-6 border-t border-border text-center">
      <p className="text-sm text-muted-foreground mb-4">
        Don't have an account yet?
      </p>
      <Button
        variant="outline"
        fullWidth
        onClick={() => navigate('/registration')}
      >
        Create New Account
      </Button>
    </div>
  );
};

export default RegistrationPrompt;